import ProgressOverlay from "Components/progressOverlay";
import { LoadPanel } from "devextreme-react/data-grid";
import React from "react";
import { createRoot } from "react-dom/client";
export default (React.createElement(LoadPanel, { enabled: true, showPane: false, showIndicator: false, onShowing: ({ element }) => {
        var _a;
        const loadContainer = (_a = element === null || element === void 0 ? void 0 : element.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".dx-loadpanel-wrapper");
        if (!loadContainer)
            return;
        createRoot(loadContainer).render(React.createElement(ProgressOverlay, { show: true }));
    } }));
